export enum StrategicalClassesType {
    All = "all",
    PosFixed = "posfixed",
    LinkedToInflation = "linkedToInflation",
    PreFixed = "prefixed"
}
